export default __webpack_public_path__ + "static/media/sample_qr-code.fdcbb29a.png";